import { CALENDAR_SETTINGS_TASK_TYPE_LABEL_SEPARATOR } from './TaskTypesFieldList.constants'

export function getCalendarSettingsTaskTypeLabel({ t, type }) {
  return type.used_by_template
    ? [type.name, t('CalendarSettings.ProcessStepHintKey')].join(
        CALENDAR_SETTINGS_TASK_TYPE_LABEL_SEPARATOR
      )
    : type.name
}
